(function () {
  if (window.__cmPdp) return;
  window.__cmPdp = 1;
  var d = document;
  var tpl = d.getElementById('cm-pdp-tpl');
  if (!tpl) return;
  var frag = tpl.content.cloneNode(true);
  var save = frag.querySelector('.cmp-save');
  var trust = frag.querySelector('.cmp-trust');
  var sticky = frag.querySelector('.cmp-sticky');
  var placed = false;

  function info() { return d.querySelector('product-info.product__info-container'); }
  function top(el, root) { while (el && el.parentElement !== root) el = el.parentElement; return el; }
  function place() {
    var root = info();
    if (!root) return false;
    var atc = root.querySelector('button[name="add"]');
    var pr = root.querySelector('[id^="price-template"]');
    var tax = root.querySelector(':scope > .product__tax');
    var desc = root.querySelector(':scope > .product__description');
    var atcTop = atc ? top(atc, root) : null;
    var priceTop = pr ? top(pr, root) : null;
    if (!atcTop || !priceTop) return false;
    if (save && !save.isConnected) (tax || priceTop).after(save);
    if (trust && !trust.isConnected) atcTop.after(trust);
    if (desc && trust && trust.previousElementSibling !== desc && desc.previousElementSibling !== trust) trust.after(desc);
    return true;
  }
  function mountSticky() {
    if (!sticky || sticky.isConnected) return;
    d.body.appendChild(sticky);
    var btn = sticky.querySelector('button');
    btn.addEventListener('click', function () {
      var root = info();
      var atc = root && root.querySelector('button[name="add"]');
      if (atc) atc.click();
    });
    var root = info();
    var atc = root && root.querySelector('button[name="add"]');
    if (!atc || !('IntersectionObserver' in window)) { sticky.classList.add('is-on'); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var below = e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', !e.isIntersecting && below);
      });
    }, { threshold: 0 }).observe(atc);
  }
  function run() {
    placed = place() || placed;
    mountSticky();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () { run(); setTimeout(run, 1200); setTimeout(run, 3000); });
})();
